module.exports = __webpack_public_path__ + "img/mob3.304b602c.png";